import React from 'react';
import TextInputModalContainer from './TextInputModalContainer.js';
import TextSearchInput from '../Components/TextSearchInput.js';
import '../consts.js';
import 'wix-rich-content-common';
import '../url-input-modal-4e7b2b25.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import '../Components/ModalCloseButton.js';
import '../Icons/ModalsCloseIcon.js';
import '../Components/SettingsMobileHeader.js';
import '../Components/Button.js';
import '../Icons/SearchIcon.js';
import '../Icons/ClearIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SearchInputModal = (props) => {
  const { dataHook, children, onCloseRequested, placeholder, onInputChange, input } = props;
  const onTextChange = (url) => {
    onInputChange(url);
  };
  return /* @__PURE__ */ React.createElement(TextInputModalContainer, __spreadValues({}, props), /* @__PURE__ */ React.createElement(
    TextSearchInput,
    {
      id: "dropdown-text-input",
      onClose: onCloseRequested,
      onChange: onTextChange,
      value: input,
      placeHolder: placeholder,
      "data-hook": `${dataHook}Input`,
      autoComplete: "off"
    }
  ), children);
};

export { SearchInputModal as default };
//# sourceMappingURL=SearchInputModal.js.map
